import { Component, ElementRef, ViewChild, inject, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '@/layout/service/layout.service';
import { AppBreadcrumb } from './app.breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AuthService } from '@/core/services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppBreadcrumb, InputTextModule, ButtonModule, IconFieldModule, InputIconModule],
    template: `<div class="layout-topbar">
        <div class="topbar-start">
            <button #menubutton type="button" class="topbar-menubutton p-link p-trigger hover:cursor-pointer" (click)="onMenuButtonClick()">
                <i class="pi pi-bars"></i>
            </button>
            <nav app-breadcrumb class="topbar-breadcrumb"></nav>
        </div>

        <div class="topbar-end">
            <ul class="topbar-menu">
                <li class="topbar-profile">
                    <button type="button" class="p-link hover:cursor-pointer" (click)="onProfileButtonClick()">
                        <img [src]="avatarSrc()" alt="Profile" />
                    </button>
                </li>
            </ul>
        </div>
    </div>`
})
export class AppTopbar {
    @ViewChild('menubutton') menuButton!: ElementRef;

    private layoutService = inject(LayoutService);
    private authService = inject(AuthService);

    private backendUrl = environment.apiUrl.replace('/api', '');

    avatarSrc = computed(() => {
        const user = this.authService.currentUser();
        if (user?.avatarUrl) {
            // Si ya es una URL absoluta la usamos directamente, si no prefijamos el backend
            return user.avatarUrl.startsWith('http')
                ? user.avatarUrl
                : `${this.backendUrl}${user.avatarUrl}`;
        }
        return '/layout/images/avatar.png';
    });

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }
}
